module.exports = __webpack_public_path__ + "img/6_PNAS_cover.9e2a0fba.jpg";